import { render, staticRenderFns } from "./comRenzheng.vue?vue&type=template&id=15c665e6&scoped=true&"
import script from "./comRenzheng.vue?vue&type=script&lang=js&"
export * from "./comRenzheng.vue?vue&type=script&lang=js&"
import style0 from "./comRenzheng.vue?vue&type=style&index=0&id=15c665e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c665e6",
  null
  
)

export default component.exports